import React, { Suspense } from 'react';
import { Router } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';

import { Spin } from 'antd';

import './config/yupConfig';
import './config/i18n';
import 'antd/dist/antd.css';
import '~/styles/override.scss';
import theme from '~/styles/theme';
import { AuthProvider } from '~/contexts/auth';

import GlobalStyles from './styles/global';
import Routes from './routes';
import history from './services/history';
import { useNetworkQuality } from './services/useNetworkQuality';
import NetworkBanner from './components/NetworkBanner';

function App() {
  const { status, lastRtt } = useNetworkQuality({
    assetUrl: '/ping.txt',
    intervalMs: 10000,
    timeoutMs: 5000,
    hysteresis: 2,
    slowRttMs: 800,
  });

  return (
    <Suspense fallback={<Spin className="page-loader" />}>
      <NetworkBanner status={status} lastRtt={lastRtt} />
      <ThemeProvider theme={theme}>
        <Router history={history}>
          <GlobalStyles />
          <AuthProvider>
            <Routes />
          </AuthProvider>
        </Router>
      </ThemeProvider>
    </Suspense>
  );
}

export default App;
